import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet } from "../../../utils/apiRequests";
import {
  GET_LATEST_LEAGUE_SMP_LOADING,
  GET_LATEST_LEAGUE_SMP_ERROR,
  GET_LATEST_LEAGUE_SMP_SUCCESS,
} from "../../../constant/actionTypes";

export const getLatestLeagueSMP = () => (dispatch) => {
  dispatch({ type: GET_LATEST_LEAGUE_SMP_LOADING });

  apiGet(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.smp}`,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_LATEST_LEAGUE_SMP_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_LATEST_LEAGUE_SMP_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_LATEST_LEAGUE_SMP_ERROR, response: error });
    }
  );
};
